import { render, staticRenderFns } from "./FiltersTable.vue?vue&type=template&id=5d052c0a&scoped=true&"
import script from "./FiltersTable.vue?vue&type=script&lang=ts&"
export * from "./FiltersTable.vue?vue&type=script&lang=ts&"
import style0 from "./FiltersTable.vue?vue&type=style&index=0&id=5d052c0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d052c0a",
  null
  
)

export default component.exports